module.exports = __webpack_public_path__ + "statics/img/logo-white.47cffa98.png";